// app wide params consist of base params,
// common to both production and development,
// along with params specific to dev / prod

import base_params from './params.base';

let override_params = {};
if (process.env.NODE_ENV === 'development') {
  override_params = require('./params.dev.js').default;
}
if (process.env.NODE_ENV === 'production') {
  override_params = require('./params.prod.js').default;
}

export default {
  ...base_params,
  ...override_params,
};



// WEBPACK FOOTER //
// ../config/params.js